import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { categoryMap, categorySlugs } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="relative aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 午马影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs leading-relaxed line-clamp-3">{movie.description}</p>
        </div>
        <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
          {movie.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500/90 text-white whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-bold rounded-md bg-accent-500/90 text-white">
            {movie.rating}
          </span>
        </div>
        {movie.tags.includes('热播') && (
          <div className="absolute bottom-2 right-2">
            <span className="px-2 py-0.5 text-[10px] font-bold rounded bg-red-500 text-white animate-pulse">
              热播
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            {movie.rating}
          </span>
          <span>|</span>
          <span>{movie.year}</span>
          <span>|</span>
          <span>{categoryMap[movie.category]}</span>
        </div>
      </div>
    </Link>
  );
}